import { useEffect, useState } from "react";
import { _AdquisitionItem, _BusinessProcess, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from "../../theme/Component/Modal";
import { toast } from "react-toastify";
import { OfferEmployee } from "../FlowHiring/OfferEmployee/OfferEmployee";
import { AdquisitionItemCDP } from "../etapa-contrato/contrac/AdquisitionItemCDP/AdquisitionItemCDP";
import { ErrorList } from "../../theme/Component/ErrorList";

interface Props {
    idAdquisitionPlanFunctionalID: number;
    idAdquisitionPlan: number;
    selectRow?: any;
    filterState?: number;
    isPreparer?: boolean;
}

export const PrevStudyAdquisitionItem = ({ idAdquisitionPlanFunctionalID, filterState, selectRow, idAdquisitionPlan, isPreparer }: Props) => {

    const { bean, setBean, lista, setLista, instance } = useDataBean(_AdquisitionItem);
    const [isValid, setIsValid] = useState<boolean>(false);
    const _busProcess = useDataBean(_BusinessProcess);

    const [msgList, setMsgList] = useState<any>([])
    const [obs, setObs] = useState<string>("")
    const [selectedAction, setSelectedAction] = useState<string>("");

    const [modalPersonal, setModalPersonal] = useState<any>({ name: "Personal Asignado", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modalCDP, setModalCDP] = useState<any>({ view: false });
    const [modalRequest, setModalRequest] = useState<any>({ name: "", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg" });
    const [modalErr, setModalErr] = useState<any>({ name: "", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-md" });

    useEffect(() => {
        getLista();
    }, [filterState, idAdquisitionPlanFunctionalID]);

    const head = [
        { title: "ID", property: "IDAdquisitionItem", visible: true, mask: MASK_NUMBER },
        { title: "Necesidad", property: "Description" },
        { title: "Rubro Presupuestal", property: "IDLnBudgetIDNameList", visible: true },
        { title: "Valor total estimado", property: "TotalValue", mask: MASK_MONEY },
        { title: "Total Rubros", property: "TotalBudget", visible: true, mask: MASK_MONEY },
        { title: 'PI', property: 'PIValue', mask: MASK_MONEY, visible: false },
        { title: 'CC', property: 'CCValue', mask: MASK_MONEY, visible: false },
        { title: 'CDP', property: 'CDPValue', mask: MASK_MONEY, visible: false },
        { title: 'RCDP', property: 'RCDPValue', mask: MASK_MONEY, visible: false },
    ];

    const getLista = () => {
        if (isPreparer && filterState == 6) {
            instance.getAdquisitionItemAprovedStateByPreparered(idAdquisitionPlanFunctionalID, _single.getAccountID())
                .then(resp => setLista(resp))
                .catch(err => console.log(err));
        } else {
            instance.getAdquisitionItemByFuncionalID(idAdquisitionPlanFunctionalID, filterState, null, null)
                .then(resp => setLista(resp.List))
                .catch(err => console.log(err));
        }
    };

    const updateState = (state?: number) => {
        instance.changeAdquisitionItemApprovalNote(bean.IDAdquisitionItem, _single.getAccountID(), obs, state ?? 43)
            .then(() => {
                setModalRequest({ ...modalRequest, view: false });
                getLista();
            })
            .catch(err => console.log(err));
    };

    const updateitem = (obj: any) => {
        instance.updateAdquisitionItem(obj).then(
            (resp: any) => {
                getLista();
                setModalRequest({ ...modalRequest, view: false });
            }
        ).catch(err => {
            console.log(err);
            toast.error("No se pudo actualizar");
        });
    }

    const handleModalSubmit = () => {
        if (!obs || obs.length < 15) {
            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.");
            setIsValid(true);
            return;
        }

        setIsValid(false);

        const initProps = {
            IDAdquisitionItem: bean.IDAdquisitionItem,
            PreparationState: bean.PreparationState,
            CodeItem: bean.CodeItem,
            IDHiringModality: bean.IDHiringModality,
            ModalityName: bean.ModalityName,
            IDLnFunctionalID: bean.IDLnFunctionalID,
            IDLnFunctionalIDName: bean.IDLnFunctionalIDName,
            TotalValue: bean.TotalValue
        };

        let processType = "";
        switch (selectedAction) {
            case "SOLOFERTA":
                processType = "SOLOFERTA";
                break;
            case "SOLCDPAI":
                processType = "SOLCDPAI";
                break;
            case "EPREVIO":
                processType = "EPREVIO";
                break;
            case "ITEMEDIT":
                processType = "ITEMEDIT";
                break;
            case "ARCON":
                processType = "ARCON";
                break;
            default:
                return;
        }

        _busProcess.instance.requestBusinessProcess(
            _single.getAccountID(),
            obs,
            processType,
            "IDAdquisitionItem",
            bean.IDAdquisitionItem,
            JSON.stringify(initProps),
            ""
        )
            .then((resp) => {
                toast.success(`Se ha Generado el Proceso ${resp.AlphaCode}`)
                setObs("");
                if (selectedAction === "ARCON") {
                    updateitem({ ...bean, PreparationState: 43, IDProcedureImp: resp.IDProcedureImp })
                } else {
                    updateState();
                }
            })
            .catch(err => console.log(err));
    };

    const listaBotonesItems = () => (
        <ListMenu listaBotones={[
            { titulo: 'CDP Asociados', icono: 'ri-file-list-line', visible: true, evento: () => setModalCDP({ ...modalCDP, view: true, name: "CDP Asociados" }) },
            {
                titulo: 'Solicitar Ofertas', icono: 'ri-play-list-add-line', visible: bean.PreparationState === 40, evento: () => {
                    setSelectedAction("SOLOFERTA");
                    setModalRequest({ ...modalRequest, view: true, name: "Iniciar Solicitud de Oferta" });
                }
            },
            {
                titulo: 'Solicitar CDP', icono: 'ri-play-list-add-line', visible: bean.PreparationState === 6, evento:
                    () => validateAndProceed(() => {
                        setSelectedAction("SOLCDPAI");
                        setModalRequest({ ...modalRequest, view: true, name: "Solicitar CDP" });
                    })
            },
            {
                titulo: 'Solicitud Estudio Previo', icono: 'ri-play-list-add-line', visible: bean.PreparationState === 44 && bean.CDPValue > 0, evento: () => {
                    setSelectedAction("EPREVIO");
                    setModalRequest({ ...modalRequest, view: true, name: "Solicitud Estudio Previo" });
                }
            },
            {
                titulo: 'Solicitud Modificación Necesidad', icono: 'ri-play-list-add-line', visible: (bean.PreparationState === 6 || bean.PreparationState === 44 || bean.PreparationState === 40), evento: () => {
                    setSelectedAction("ITEMEDIT");
                    setModalRequest({ ...modalRequest, view: true, name: "Solicitud Modificación Necesidad" });
                }
            },
            {
                titulo: 'Solicitud Documentacion Contractual', icono: 'ri-play-list-add-line', visible: (bean.PreparationState === 6), evento: () => {
                    if (!bean.IDHiringModality) {
                        toast.error("No se pude Iniciar la solicitu sin una modalidad de Contratacion")
                        return;
                    }

                    setSelectedAction("ARCON");
                    setModalRequest({ ...modalRequest, view: true, name: "Solicitud Documentacion Contractual" });
                }
            },
            // validateAndProceed(() => {}
            // {
            //     titulo: 'Solicitud Crédito/ContraCrédito', icono: 'ri-play-list-add-line', visible: bean.PreparationState === 41, evento: () => validateAndProceed(() => {
            //         setSelectedAction("SOLCCAI");
            //         setModalRequest({ ...modalRequest, view: true, name: "Solicitud Estudio Previo" });
            //     })
            // },
            { titulo: "Personal", icono: "ri-group-line", visible: true, evento: () => setModalPersonal({ ...modalPersonal, view: true }) },
        ]} />
    );

    useEffect(() => {
        if (msgList.length > 0) {
            setModalErr({ ...modalErr, "view": true, "name": "Errores en la Necesidad" })
        }
    }, [msgList])

    const validateAndProceed = (execute: () => void) => {
        instance.validateAdquisitionItem(bean.IDAdquisitionItem)
            .then((resp) => {
                if (resp.length > 0) {
                    toast.error("No se puede continuar. Hay errores en la validación.");
                    setMsgList(resp)
                } else {
                    execute();
                }
            })
            .catch(err => {
                console.error("Error en validación:", err);
                toast.error("Ocurrió un error en la validación.");
            });
    };

    const setRowBean = (obj: any) => {
        setBean(obj);
        selectRow?.(obj);
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable listButtons={listaBotonesItems()} head={head} body={lista} rowSet={setRowBean} />
            </div>

            <div className="col-md-12">
                <Modal modal={modalCDP} updateModal={setModalCDP}>
                    <AdquisitionItemCDP adquisitionItem={bean} />
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal onSubmitLabel="Solicitar" modal={modalRequest} updateModal={setModalRequest} eventModal={handleModalSubmit}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea
                                name="obs"
                                rows={5}
                                className={`form-control ${isValid ? "is-invalid" : ""}`}
                                value={obs}
                                onChange={(e) => setObs(e.target.value)}
                            />
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalPersonal} updateModal={setModalPersonal}>
                    <OfferEmployee updateFather={getLista} IDAdquisitionItem={bean.IDAdquisitionItem} />
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalErr} updateModal={setModalErr}>
                    <ErrorList lista={msgList} />
                </Modal>
            </div>
        </div>
    );
};
